<template>
  <div class="offerpopup">
    <h1 class="fs-14 pb8 color-slaty">{{ dataTitle }}</h1>
    <p class="pb16 fs-20 bold plr16">{{ dataDescription }}</p>
    <!-- <hr class="line" />
    <button class="astext bold tc" @click="closeAppliedModal()">
      <span :style="{ paddingLeft: dataPaddingLeft }">{{ dataAction }}</span>
    </button> -->
  </div>
</template>
<script>
import { keyMapsMutation } from "../helpers/storeKeys";
export default {
  name: "OfferSelectedPopup",
  props: ["dataTitle", "dataDescription", "dataAction", "dataPaddingLeft"],
  methods: {
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");

      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false
      );
    },
  },
  computed: {},
};
</script>
<style></style>
